import supportWebP from "./supportWebp";

/**
 * @param {string} 相对path
 * @return {string} 完整oss地址
 */

export default function getFullWebCdnUrl(path: string, transform = true): string {
	const OSSCndPrefix = process.env.NEXT_PUBLIC_APP_OSS_PUBLIC_CND + "/h5";

	if (supportWebP.getSupportWebP() || !transform) {
		return `${OSSCndPrefix}${path}`;
	}

	return `${OSSCndPrefix}${path}?x-oss-process=image/format,png`;
}

export function transformWebCdnUrl(ossFullpath: string): string {
	if (supportWebP.getSupportWebP()) {
		return `${ossFullpath}`;
	}

	return `${ossFullpath}?x-oss-process=image/format,png`;
}

export function getCDNWithWebp(path: string): string {
	const OSSCndPrefix = process.env.NEXT_PUBLIC_APP_OSS_PUBLIC_CND + "/h5";
	const optimize = supportWebP.getSupportWebP() ? "webp" : "png";

	return `${OSSCndPrefix}${path}?x-oss-process=image/format,${optimize}`;
}

export function ossFullUrl(path: string): string {
	const OSSCndPrefix = process.env.NEXT_PUBLIC_APP_OSS_PUBLIC_CND + "/h5";

	return `${OSSCndPrefix}${path}`;
}
